module.exports = __webpack_public_path__ + "static/miro-6689ee8bb1480d4737b068a832b53b7c.png";